export default "__VITE_ASSET__DL7dEs_R__"